import { createSelector } from 'reselect';
import { compose, sortBy, get, find } from 'lodash/fp';
import { getStringProp } from '@mews/fp';
import { PAYMENT_TERMINAL_FETCH } from '../actions/constants';
import { reducersFactory, selectorsFactory } from '../factory/reducers';

export const NAME = 'paymentTerminals';

const { paymentTerminalsReducer } = reducersFactory({ name: NAME, baseAction: PAYMENT_TERMINAL_FETCH });
export default paymentTerminalsReducer;

export const { getPaymentTerminals, getLastUpdated, isFetching, isLoaded } = selectorsFactory({
    name: NAME,
    entityMapper: sortBy('ordering'),
});

export const isLoading = createSelector(isLoaded, isFetching, (loaded, fetching) => !loaded || fetching);

export const getPaymentTerminal = createSelector(
    getPaymentTerminals,
    getStringProp('paymentTerminalId'),
    (terminals, paymentTerminalId) => find({ id: paymentTerminalId })(terminals)
);

export const getPaymentTerminalAcceptedCurrencies = compose(get('acceptedCurrencyCodes'), getPaymentTerminal);

export const getIsStripeTerminal = compose(get('isStripeTerminal'), getPaymentTerminal);
